export enum DeliveryType {
    SELF_DELIVERY = 'Self Delivery',
    BETTY_DELIVERY = 'Betty Delivery',
    UBER_DELIVERY = 'Uber Delivery',
}